import React from 'react';
import { FormControl, FormControlLabel as MuiFormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';

import type { CustomStep } from '@shared/patient-intake-status';

type MessageMetadata = CustomStep['MESSAGE']['metadata'];

type MessageContext = MessageMetadata['messageContext'];

interface FormControlLabelProps extends React.ComponentProps<typeof MuiFormControlLabel> {
  value: MessageContext;
}

const FormControlLabel: React.FC<FormControlLabelProps> = (props) => <MuiFormControlLabel {...props} />;

const MESSAGE_CONTEXT_VALUES = {
  nurse: 'Nurse chat',
  doctor: 'Doctor chat',
  support: 'Support chat',
} satisfies Record<MessageContext, string>;

type MessageMetadataProps = {
  value: MessageMetadata;
  onChange: (value: MessageMetadata) => void;
  error?: string;
};

export const MessageMetadata: React.FC<MessageMetadataProps> = ({ value, onChange, error }) => (
  <FormControl component="fieldset" fullWidth margin="normal" error={!!error}>
    <FormLabel component="legend">Where should the chat take place?</FormLabel>
    <RadioGroup
      value={value.messageContext}
      onChange={(e) =>
        onChange({
          ...value,
          messageContext: e.target.value as MessageContext,
        })
      }
    >
      {Object.entries(MESSAGE_CONTEXT_VALUES).map(([value, label]) => (
        <FormControlLabel key={value} value={value as MessageContext} control={<Radio />} label={label} />
      ))}
    </RadioGroup>
  </FormControl>
);
